import Connection from '../connection';

const BASE_PATH = '/slack';

export function loadTeam(userId) {
  return Connection.send(`${BASE_PATH}/team`, { userId });
}

export function loadChannels(userId, teamId) {
  return Connection.send(`${BASE_PATH}/channels/${userId}/${teamId}`);
}

export function updateBlacklist({ userId, teamId, removeIds, addIds }) {
  return Connection.send(
    `${BASE_PATH}/channels/blacklist/massUpdate`, {
      userId,
      teamId,
      removeIds,
      addIds,
    }, 'POST');
}

export function addToBlacklist({ userId, teamId, channelId }) {
  return Connection.send(`${BASE_PATH}/channels/blacklist/add`, { userId, teamId, channelId }, 'POST');
}

export function removeFromBlacklist({ userId, teamId, channelId }) {
  return Connection.send(`${BASE_PATH}/channels/blacklist/remove`, { userId, teamId, channelId }, 'POST');
}



// WEBPACK FOOTER //
// ./src/services/api/slack.js